import React from "react";
import { logToAndylitics } from "../../api/andyliticsApi";
import * as Tools from "../../helpers/Tools";
import { connect } from "react-redux";
import PropTypes from 'prop-types';

class MobileAppDownload extends React.Component {
    constructor(params) {
        super(params);
        const ssoBaseURL = `${window.serverData.data.ssoBaseURL}`;
        this.GOOGLE_PLAY_URL = `${ssoBaseURL}app_download/android`;
        this.IPHONE_APP_URL = `${ssoBaseURL}app_download/iphone`;

        //this.downloadMobileApp = this.downloadMobileApp.bind(this);
        this.downloadAndroidMobileApp = this.downloadAndroidMobileApp.bind(this);
        this.downloadiOSMobileApp = this.downloadiOSMobileApp.bind(this);
    }
    componentDidMount() {
        logToAndylitics('MBHWeb.UI.MobileApp.AppDownload.LOAD', new Date(), '/AppDownload');
       // this.downloadMobileApp();
    }

    //downloadMobileApp() {
    //    //DOWNLOAD APP BUTTON THAT DIRECTS USER TO CORRESPONDING APP STORE TO DOWNLOAD APP    
    //    const isAndroid = Tools.isAndroid();
    //    const isIos = Tools.isIos();
    //    const isIPad = Tools.isIPad();
    //    const dDate = new Date();
    //    if (isIos || isIPad) {
    //        if (typeof window !== 'undefined')
    //            window.location.href = this.IPHONE_APP_URL;
    //        logToAndylitics('MBHWeb.MobileApp.iTunes.Redirect', new Date(),'/iTunesDownload');
    //    }
    //    else if (isAndroid) {
    //        if (typeof window !== 'undefined')
    //            window.location.href = this.GOOGLE_PLAY_URL;
    //        logToAndylitics('MBHWeb.MobileApp.GooglePlay.Redirect', new Date(), '/GooglePlayDownload');
    //    }
    //}

    downloadiOSMobileApp() {
        //DOWNLOAD APP BUTTON THAT DIRECTS USER TO CORRESPONDING APP STORE TO DOWNLOAD APP        
        const dDate = new Date();
        if (typeof window !== 'undefined')
            window.location.href = this.IPHONE_APP_URL;
        logToAndylitics('MBHWeb.MobileApp.iTunes.Redirect', new Date(), '/iTunesDownload');
        
    }
    downloadAndroidMobileApp() {
        //DOWNLOAD APP BUTTON THAT DIRECTS USER TO CORRESPONDING APP STORE TO DOWNLOAD APP        
        const dDate = new Date();
        if (typeof window !== 'undefined')
            window.location.href = this.GOOGLE_PLAY_URL;
        logToAndylitics('MBHWeb.MobileApp.GooglePlay.Redirect', new Date(), '/GooglePlayDownload');        
    }
    render() {
        const { serverData } = this.props;

        return (
            <div className="container-fluid body-content mobile-app-download-container">
                <div className="row">
                    <div className="col-12 maxWidth-content">
                        <h1 className="page-heading">Getting better starts here</h1>

                        <div className="row">
                            <div className="col-12 col-sm-6">
                                <span>With the MyBSWHealth App you can manage your health from anywhere.</span>
                                <div className="ratings">
                                    <h3>4.7 Rating</h3>
                                    <img alt="star-rating" src="images/stars-my-care-tasks.png" />
                                    <span>With 25k+ reviews & 500k+ users</span>
                                </div>
                                <div className="app-icons">
                                    <a href="https://itunes.apple.com/us/app/mybswhealth/id1000856979?mt=8" onClick={this.downloadiOSMobileApp}>
                                        <img alt="App store" src="images/app-store.png" />
                                    </a>
                                    <a href="https://play.google.com/store/apps/details?id=com.baylorscottandwhite.healthsource&hl=en" onClick={this.downloadAndroidMobileApp}>
                                        <img alt="Google store" src="images/google-store.png" />
                                    </a>
                                </div>
                            </div>
                            <div className="col-12 col-sm-6 phone-img">
                                <img alt="MyBSWHealth app" src="images/mobile-app-page.png" className="img-fluid" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

}

const mapStateToProps = (state) => {
    return {
        serverData: state.session.serverData,
    };
};
export default connect(mapStateToProps, null)(MobileAppDownload);
